import gql from 'graphql-tag';

export const GET_USERS = gql`
  query {
    weployer {
      currentOrganisation {
        id
        weployers {
          email
          id
          isCurrentUser
          lastActive
          hasActiveJobs
          name
          policy {
            role
          }
        }
        visibleInvitations {
          id
          receiverRole
          status
          recipientEmail
          canResend
        }
      }
    }
  }
`;

export const CHANGE_WEPLOYER_ROLE_MUTATION = gql`
  mutation ($organisationId: ID!, $weployerId: ID!, $role: WeployerPolicyRoleEnum!) {
    weployer {
      updateRole(weployerId: $weployerId, role: $role, organisationId: $organisationId) {
        weployerId
        role
      }
    }
  }
`;

export const CREATE_INVITATION_MUTATION = gql`
  mutation ($recipientEmail: String!, $receiverRole: WeployerPolicyRoleEnum! ){
    weployer {
      createInvitation(recipientEmail: $recipientEmail, receiverRole: $receiverRole) {
        id
      }
    }
  }
`;

export const DELETE_ORGANISATION_USER_MUTATION = gql`
  mutation ($weployerId: ID!) {
    weployer {
      deleteOrganisationUser(weployerId: $weployerId) {
        weployerId
        organisationId
      }
    }
  }
`;
